import Abstract from './abstract';
import Toast from './toast';

export default class CopyClipboard extends Abstract {
  constructor() {
    super();

    this.toast = new Toast();
  }

  init() {
    this.getElement();

    this.addEvent();
  }

  getElement() {
    this.copyTextClipboardElements = document.querySelectorAll(
      '.js-copy-clipboard-text',
    );
  }

  addEvent() {
    this.copyTextClipboardElements.forEach((copyTextClipboardElement) => {
      copyTextClipboardElement.addEventListener('click', () => {
        this.copyToClipboard(copyTextClipboardElement.dataset.text);
      });
    });
  }

  copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.toast.show(
          'テキストがクリップボードにコピーされました',
          'success',
        );
      })
      .catch((err) => {
        console.error('Failed to copy text to clipboard:', err);
        this.toast.show('クリップボードへのコピーに失敗しました', 'error');
      });
  }
}
